import Bowser from 'bowser'
import md5 from "md5";
const pako = require('pako')
const Base64 = require("js-base64").Base64;
import router from '../router/index.js'
import axios from 'axios'
import {setCookie,getCookie} from '../utils/index.js'
const { aid, sid, svid, passCode, serverUrl, projectId } = require("./config.js");

const Authorization = "Basic" + " " + Base64.encode(`${aid}:${passCode}`);
/**
 * 生成uuid, 指定长度和基数
 * @returns string
 */
const dcpInstance = axios.create({
    baseURL: serverUrl,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
  
  // 添加响应拦截器
  dcpInstance.interceptors.response.use(
    function (response) {
        console.log("=======response",response)
        return response.data || response
    },
    function (error) {
        console.log(error)
        return Promise.reject(error)
    }
  )
function getUuid(len=16, radix=16) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    let uuid = []
    let i
    radix = radix || chars.length
    if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
        let r
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
            }
        }
    }
    return uuid.join('')
}
function getDid(){
    // 获取当前时间戳（单位：毫秒）
    var timestamp = Date.now();
    // 生成13位的随机数
    var randomNum = Math.random().toString(16).substring(2);
    // 将随机小数转换为字符串并保留两位小数点
    var did = timestamp + '_' + randomNum;
    // 将时间戳与随机数连接起来形成最终的时间戳
    setCookie('dcpDID',did)
    return did;
}
dcpInstance.track = async function (type, name, data = {}) {
    const browser = Bowser.getParser(window.navigator.userAgent)
    let uuid = getUuid();
    let ts = new Date().getTime()
    let params = {};
    console.log("router=========",router,type,name)
    let defaultData = {
        G1: uuid,//数据内容标唯一标识id ，必填
        G2: '',//账号类别 枚举：idpuserId、deviceId、vin、phoneNumber，必填
        G3: '',//用户账号，必填
        G4: projectId,//项目对应的id ，必填
        G5: 'SA', //项目类别枚举值,页调用此处 默认为“SA”，必填
        G6: data.channelId || "", //渠道id
        G7: '', // SDK类型 sdk_type app上用的
        G8: '', // SDK版本 app上用的
        G9: '', // 应用ID
        G10: '',//APP应用的版本
        G11: browser.parsedResult.os.name || '', //操作系统 ，必填
        G12: (browser.parsedResult.os.version && browser.parsedResult.os.version.toString()) || '',//操作系统版本，必填
        G13: navigator.platform || '', //硬件设备名称  ，必填
        G14: browser.parsedResult.browser.name || '', ///客户端名称,
        G15: (browser.parsedResult.browser.version && browser.parsedResult.browser.version.toString()) || '',//客户端版本
        G16: document.documentElement.clientWidth + 'x' + document.documentElement.clientHeight || '', //屏幕分辨率,
        G17: '', //网络类型
        G18: type == 'pv' ? name : '', //当前页面 ，必填
        G19: router.history.current.meta.prePageName || '', //上一个页面
        G20: "", // 目标页面名称，用于跳转（跳转的页面）
        G21: '', //停留时长
        G22: type == 'act' ? name : '', //事件名称
        G23: type, // 事件的类型 (事件或页面) 。固定：类型为事件时填写“act“,类型为页面时填写”pv“。
        G24: '', // IP
        G25: '', // IPV6
        G26: data.activityId || '', //活动id
        G27: data.carId || '', //车系id
        G28: data.seriesId || '', //车系名称
        G29: data.openId || '', //openid
        G30: data.circleId || '', //帖子ID
        G31: data.circleChildId || '', //子帖子ID
    }
  
    if (Object.keys(data) > 0) {
      defaultData = Object.assign(defaultData, data)
    }
    // mid  	Y	消息ID（由程序自动生成的id）
    // aid  	Y	应用ID（用户在平台申请的应用的id，用户传入）
    // sid  	Y	数据模板ID（用户在平台申请的应用的数据模板id，用户传入）
    // svid 	Y	数据模板版本ID（用户在平台申请的模板的版本id，用户传入）
    // did  	Y	设备id （deviceid）
    // ts  	    Y	数据采集时间戳（该时间为数据生成时间）
    // d	    Y	采集的数据
    params = {
        records: [{
            value: {
                mid: uuid,
                did: getCookie('dcpDID') ? getCookie('dcpDID') : getDid(),
                aid: aid,
                sid: sid,
                svid: svid,
                ts: ts,
                d: defaultData,
            }
        }],
    }
    console.log('params: ', params)
    let body = pako.gzip(JSON.stringify(params))
    let md5Code = md5(JSON.stringify(params))
    let { status } = dcpInstance.post('/dcp/v1/message', body, {
        headers: {
            'Content-Type': 'application/json',
            'Content-Encoding': 'gzip',
            Accept: '*/*',
            RequestId: uuid,
            Authorization: Authorization,
            'Content-md5': md5Code,
        }
    })
    return status
}
export default dcpInstance